import React from 'react';
import styled from 'styled-components';
import { Popup } from '../../components/Popup';
import { TextInput } from '../../components/TextInput';
import { MarginRight20, MarginTop10 } from '../../components/margins';
import { InputBoolean } from '../../components/InputBoolean';
import { VALIDATORS_TYPE } from '../../utils/constants';

const PopupRadioButtonsContainer = styled.div`
    margin-top: 30px;
    display: flex;
    flex-wrap: wrap;
`;

const RadioButtonWrapper = styled.div`
    ${MarginRight20};
`;

const TextWrapper = styled.div`
    ${MarginTop10};
`;

export const CFPopup = ({
    isOpened = false, closePopup = () => { },
    isGenderMale, placeOfBirth, dateOfBirth,
    onChangeText, onChangeGender, callback
}) => {
    return (
        <React.Fragment>
            {isOpened &&
                <Popup
                    close={closePopup}
                    title="CALCOLA IL CODICE FISCALE"
                    buttonText="Calcola"
                    buttonCallback={callback}
                >
                    <div style={{ padding: '0px 30px' }}>
                        <TextWrapper>
                            <TextInput
                                labelText="Comune di nascita*"
                                onValueChange={e => onChangeText('placeOfBirth', e)}
                                value={placeOfBirth}
                            />
                        </TextWrapper>
                        <TextWrapper>
                            <TextInput
                                labelText="Data di nascita*"
                                onValueChange={e => onChangeText('dateOfBirth', e)}
                                value={dateOfBirth}
                                placeholder="gg/mm/aaaa"
                                validator={VALIDATORS_TYPE.noValidation}
                            />
                        </TextWrapper>
                        <PopupRadioButtonsContainer>
                            <RadioButtonWrapper>
                                <InputBoolean
                                    type="radio"
                                    onChange={_ => onChangeGender(true)}
                                    label="UOMO"
                                    name="gender"
                                    isChecked={isGenderMale}
                                />
                            </RadioButtonWrapper>
                            <RadioButtonWrapper>
                                <InputBoolean
                                    type="radio"
                                    onChange={_ => onChangeGender(false)}
                                    label="DONNA"
                                    name="gender"
                                    isChecked={!isGenderMale}
                                />
                            </RadioButtonWrapper>
                        </PopupRadioButtonsContainer>
                    </div>
                </Popup>
            }
        </React.Fragment>
    )
}